export const LOG_IN_SUCCESS = 'LOG_IN_SUCCESS';
export const LOG_IN_FAILURE = 'LOG_IN_FAILURE';
export const RECEIVE_REFRESH_TOKEN = 'RECEIVE_REFRESH_TOKEN';
export const LOG_OUT = 'LOG_OUT';

export const LIST = 'LIST';
export const ADD = 'ADD';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';
export const SELECT_ITEM = 'SELECT_ITEM';
export const UPDATE_SELECTED_ITEM = 'UPDATE_SELECTED_ITEM';
export const CLEAR_LIST = 'CLEAR_LIST';
export const CLEAR_SELECTED_ITEM = 'CLEAR_SELECTED_ITEM';
export const FAILURE = 'FAILURE';

export const API_REQUEST = 'API_REQUEST';
export const API_RESPONSE = 'API_RESPONSE';
export const API_CLEAR_STATE = 'API_CLEAR_STATE';

export const ADD_FLASH_MESSAGE = 'ADD_FLASH_MESSAGE';
export const REMOVE_FLASH_MESSAGE = 'REMOVE_FLASH_MESSAGE';


